export const skillPathsClassNames = {
  root: 'academy-skill-paths',
  grid: 'academy-skill-paths-grid',
  card: 'academy-skill-path-card',
  skillList: 'academy-skill-path-list',
  skillListItem: 'academy-skill-path-list-item',
};
